import { useMemo } from 'react';
import {
    APIType,
    ContouringCustomizationFile,
    UserCustomization,
} from '~/backend/types';
import type { IdentifiedRoi } from '~/domain/comparison/roiCounterpart';
import type { ContourModelChoice } from '~/state/atoms/adaptiveReplanningAtoms';
import { transformModelRoiNames } from '~/utils/transforms/modelRoiTransforms';
import { useModelCustomizations } from '../useBackend';

const NONE: IdentifiedRoi[] = [];

// Every structure the chosen model's customization offers, whether or not it is included by default.
export function useQaModelRois(
    choice: ContourModelChoice | undefined
): IdentifiedRoi[] {
    const { data: customizations } = useModelCustomizations(APIType.CONTOURING);
    return useMemo(() => {
        if (!choice || !customizations) {
            return NONE;
        }
        return transformModelRoiNames(
            customizations as UserCustomization<ContouringCustomizationFile>[],
            choice.modelName,
            choice.customizationName
        ).rois;
    }, [customizations, choice]);
}
